<template>
  <div class="checkout-credit-card-container">
    <form id="checkout-credit-card-form">
      <input type="hidden" name="omiseToken" />
      <input type="hidden" name="omiseSource" />
      <button id="checkout-button" @click.prevent="triggerOmisePayment">Pay now</button>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import API from '@/lib/api'
import { OMISE_PUBLIC_KEY } from '@/lib/global'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

const { mapFields: mapPaymentFields } = createHelpers({
  getterType: 'getPaymentFields',
  mutationType: 'updatePaymentFields',
})

export default {
  name: 'CreditCardCheckout',
  data: () => ({
    totalPrice: 0,
  }),
  props: ['application_id'],
  watch: {
    isLoading() {
      if (this.isLoading) {
        this.$swal({
          title: 'Now processing',
          text: 'Please do not refresh this page.',
          allowEscapeKey: false,
          allowOutsideClick: false,
          onOpen: () => {
            this.$swal.showLoading()
          },
        })
      }
    },
    isError() {
      if (this.isError) {
        this.$swal({
          type: 'error',
          title: 'เกิดข้อผิดพลาดในการชำระเงิน',
        }).then(() => (this.isError = false))
      }
    },
    applicationInformation: {
      handler(data) {
        this.triggerOmisePayment(data)
      },
      deep: true,
    },
  },
  computed: {
    ...mapApplicationFields({
      applicationInformation: 'data.applicationInformation',
    }),
    ...mapPaymentFields({
      isLoading: 'creditCard.isLoading',
      isError: 'creditCard.isError',
    }),
  },
  mounted() {
    OmiseCard.configure({
      publicKey: OMISE_PUBLIC_KEY,
    })

    this.getApplicationInformation(this.application_id)
  },
  methods: {
    ...mapActions(['getApplicationInformation', 'payViaCreditCard']),
    triggerOmisePayment(data) {
      const isCombinePayment = _.get(data, 'familyQuotation.isCombinePayment', false)
      const payerFirstname = _.get(data, 'payer.firstname', '')
      const payerLastname = _.get(data, 'payer.lastname', '')

      const familyTotalPrice = _.get(data, 'familyQuotation.pricingSum', 0)
      const personalTotalPrice = _.get(data, 'pricing.netPremium', 0)

      const totalPrice = isCombinePayment ? familyTotalPrice : personalTotalPrice

      OmiseCard.open({
        amount: totalPrice * 100,
        currency: 'THB',
        frameDescription: `ผู้ชำระเบี้ย - ${payerFirstname} ${payerLastname}`,
        frameLabel: 'บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)',
        image: API.DOCUMENTS.TVI_LOGO,
        defaultPaymentMethod: 'credit_card',
        onCreateTokenSuccess: omiseToken =>
          this.payViaCreditCard({
            amount: totalPrice * 100,
            omiseToken,
            applicationId: this.application_id,
            isCombinePayment,
          }),
        onFormClosed: () => console.log('onFormClosed'),
      })
    },
  },
}
</script>

<style lang="scss">
#checkout-credit-card-form {
  display: none;
}
</style>
